import type { ProductLogoSmallProps } from '../types';

/**
 * 小サイズのStorageAndFilesロゴアイコン
 */
export function ProductLogoSmallStorageAndFiles({
  size = 20,
  color = '#1874A1',
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 480 480"
      fill="none"
      {...props}
    >
      <path
        d="M42 264C42 283.882 103.785 300 180 300C199.163 300 217.414 298.979 234 297.138V345.138C217.414 346.979 199.163 348 180 348C103.785 348 42 331.882 42 312V264Z"
        fill={color}
      />
      <path
        d="M318 240C318 244.537 314.781 248.877 308.909 252.875C306.342 252.299 303.701 252 301.029 252H270C255.57 252 243.124 260.491 237.383 272.748C219.909 274.835 200.475 276 180 276C103.785 276 42 259.882 42 240V192C42 211.882 103.785 228 180 228C256.215 228 318 211.882 318 192V240Z"
        fill={color}
      />
      <path
        d="M318 168C318 187.882 256.215 204 180 204C103.785 204 42 187.882 42 168V120C42 139.882 103.785 156 180 156C256.215 156 318 139.882 318 120V168Z"
        fill={color}
      />
      <path
        d="M180 60C256.215 60 318 76.1177 318 96C318 115.882 256.215 132 180 132C103.785 132 42 115.882 42 96C42 76.1177 103.785 60 180 60Z"
        fill={color}
      />
      <path
        d="M301.029 276C304.212 276 307.264 277.264 309.515 279.515L326.485 296.485C328.736 298.736 331.788 300 334.971 300H426C432.627 300 438 305.373 438 312V408C438 414.627 432.627 420 426 420H270C263.373 420 258 414.627 258 408V288C258 281.373 263.373 276 270 276H301.029Z"
        fill={color}
      />
    </svg>
  );
}
